<template>
    <section class="bg-light px-6 pt-8 pb-7">
        <nav class="tab__nav" v-if="!store.view_only.value">
            <button 
                v-for="(section, sectionName, index) in store.form.steps.availableStages.value" 
                @click="store.form.steps.current_stage.value = sectionName" 
                
                type="button"
                class="tab--link" 
                :class="{
                    'active'    : store.form.steps.current_stage.value === sectionName,
                    'disabled'  : !store.form.steps.canActivateStage(sectionName),
                    'completed' : store.form.steps.isValid(sectionName) && store.form.steps.hasActivatedStage(sectionName) && store.form.steps.current_stage.value !== sectionName,
                }" 
                
                :data-title="'Step ' + parseInt(index + 1) + ': ' + section.title"
                :disabled="!store.form.steps.canActivateStage(sectionName)"
            >
                Step {{ index + 1 }}: {{ section.title }}
            </button>
        </nav>

        <TabPanel 
            v-for="(section, sectionName, index) in store.form.steps.stages"
            :uuid="sectionName"
        >
            <template #content v-if="store.form.steps.current_stage.value === sectionName"> </template>
            <component 
                v-if="section?.component" 
                :is="section.component"
            />
        </TabPanel>

        <StepFooter 
            v-if="!store.view_only.value"

            previous-step-label="Back a Step"
            :next-step-label="nextStepLabel"
            :submission-label="submissionLabel"

            next-step-class="btn--secondary"

            :has-progression="false"

            :is-first-step="store.form.steps.isFirstStage.value"
            :is-last-step="store.form.steps.isLastStage.value"
            :is-valid="store.form.steps.activeStage?.value?.isValid?.value"

            :loading="store.form.actions.submit.loading.value"

            @next="onNext"
            @previous="store.form.steps.previousStep"
        />
    </section>
</template>

<script setup>
    import store from "@app/booking/state/store.js"
    import TabPanel from "@app/components/form-tabs/TabPanel.vue";
    import StepFooter from "@app/memberships/components/partials/StepFooter.vue";
    import { computed } from "vue";

    const props = defineProps({
        eventId        : [String, Number],
        eventBookingId : [String]
    })

    const nextStepLabel = computed(
        () => {
            switch(store.form.steps.nextStageName.value){
                case 'tickets':
                    return 'Select Ticket Type'
                case 'workshops':
                    return 'Select Workshops'
                case 'extras':
                    return 'Select Options'
                case 'attendees':
                    return 'Add Attendees'
                case 'confirmation':
                    return 'See Booking Overview'
                default:
                    return 'Next Step'
            }
        }
    )

    const submissionLabel = computed(
        () => store.form?.fields?.value?.ticket?.ticket?.cheapest_price?.price == 0 
            ? 'Confirm Booking'
            : 'Continue To Payment'
    )

    const onNext = () => {
        if(!store.form.steps.isLastStage.value){
            store.form.steps.nextStep()
        } else {
            store.form.actions.submit.api.execute()
        }
    }
</script>